import create from 'zustand'
import immer from './immer'
import { devtools } from "zustand/middleware"
let useFacultyStore = (set) => ({
    faculties: [],
    subjects: [],
    addAllSubjects: (subs) => set((state) => void (state.subjects = subs)),
    // branch: {},
    // setBranch: (branch) => set(state => void (state.branch = branch)),
    addFaculty: (faculty) => set((state) => {
        const ind = state.faculties.filter((ele, index) => {
            if (ele._id == faculty._id) {
                state.faculties[index] = faculty;
                return true;
            }
        });
        if (!ind || ind.length < 1) {
            state.faculties.push(faculty);
        }
    }),
    addAllFaculties: (facs) => set((state) => void (state.faculties = facs)),
})
useFacultyStore = devtools(useFacultyStore, { name: "faculties" });
useFacultyStore = immer(useFacultyStore);
export default create(useFacultyStore);